
<div #element class="chart-container">
    <!-- <canvas [id]="chartId" #chartTarget>{{ chart }}</canvas> -->
</div>

